/**
 * PUSH const symbols.
 * @constant
 * @type {Object}
 */



const PUSH = {
    TAG: 'tag',
    ALIAS: 'alias',
    TAG_OPEN_APP: 'OpenApp',
    TAG_OPEN_APP_VER: 'OpenAppVer',
    TAG_LOGIN: 'login',
    OPEN_APP_VER: 'openappver',
    CHANGE_TO:  '\'',
    CHANGE_FROM: 'abffcd',
    UA: 'com.urbanairship.in_app',
    EXTRA: 'extra',
    IOS: 'ios',
    ACTION: 'action'


};


export {PUSH};